// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FormasPagamentoFranquia_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/formas_pagamento_franquias/remover
 *
 * Apaga a aplicação da forma na franquia, que volta a herdar o padrão global (chamado 2026-0023).
 */
import { registerContract } from './validate'

export interface FormasPagamentoFranquia_RemoverInput {
forma_pagamento_id: number
franquia_id: number
}

registerContract('FormasPagamentoFranquia_RemoverInput', {
  forma_pagamento_id: { type: 'number',  required: true },
  franquia_id:        { type: 'number',  required: true },
})
